
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(7(3|323|591|610)|(147|524|997)2|1360|2646|3775|4294|5513|6483|8279)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
